import * as React from 'react';
import { Layout, Button, Popover, Dropdown, Menu, Popconfirm } from 'antd';
import { connect } from 'react-redux';
import { Redirect, Route, withRouter } from 'react-router';
import RouteWithSubRoutes from '../route_with_sub_routes/RouteWithSubRoutes';
import SubnavTabs from '../subnav_tabs/SubnavTabs';
import {
	assetsRestCrudThunksForSupplier,
	cancelScheduledAssetTransfer,
} from '../../thunks/assets_thunks';
import BulkTransferToLocationModal from '../supplier_assets_index_page/BulkTransferToLocationModal';
import BulkTransferToStockLocationModal from '../supplier_assets_index_page/BulkTransferToStockLocationModal';
import {
	getProtectedImageUriForSupplier,
	getProtectedImageUriFromString,
} from '../../utils/FileAccessUtils';
import { Link } from 'react-router-dom';
import { getEntityById, nullSafeGet } from '../../utils/DataAccessUtils';
import { ROLE_TYPES } from '../../utils/DataConstants';
import Carousel, { Modal as Lightbox, ModalGateway } from 'react-images';
import { clearNavbarState, updateNavbarState } from '../../actions/navbar_actions';
import {
	generateBackLink,
	getBackLinkStates,
	getLinkWIthBackLinkParams,
} from '../../utils/HistoryUtils';
import { PERMISSION_NAMES } from '../../utils/AuthUtils';
import { getScheduledTransferInitialValues } from '../../utils/assetUtils';
import AccessPermissionChecker from '../common/AccessPermissionChecker';
import NextPreviousButton from '../next_previous_button/NextPreviousButton';
import { ASSETS_CRUD_ACTION_CREATORS } from '../../actions/assets_actions';
import { updatePaginationEntities } from '../../thunks/thunks_wrapper';
import DeleteConfirmButton from '../delete_pop_confirm/DeletePopConfirm';

const { Content } = Layout;

require('./SupplierAssetsDetailPage.less');

const DEFAULT_BACK_LINK = '/supplier/assets/overview/all';
const DEFAULT_BACK_TEXT = 'Back to assets';

class SupplierAssetsDetailPage extends React.Component<any, any> {
	constructor(props) {
		super(props);
		this.state = {
			lightboxIsOpen: false,
			currentIndex: 0,
			manualsIncluded: false,
			transferModal: null,
			fromTargetCollectionName: null,
		};
	}

	handleViewChange = (idx) => {
		this.setState({ currentIndex: idx });
	};

	openLightbox = (currentIndex = 0) => {
		this.setState({ lightboxIsOpen: true, currentIndex });
	};

	closeLightbox = () => {
		this.setState({ lightboxIsOpen: false });
	};

	componentWillUnmount(): void {
		this.props.clearNavbar();
	}

	populateNavBar = () => {
		const { location, updateNavbar } = this.props;
		const {
			backLinkText = DEFAULT_BACK_TEXT,
			backLinkTo,
			fromTargetCollectionName = null,
		} = getBackLinkStates(location, DEFAULT_BACK_LINK) as any;
		this.setState({ fromTargetCollectionName });
		updateNavbar(
			backLinkText || DEFAULT_BACK_TEXT,
			backLinkTo || generateBackLink(DEFAULT_BACK_LINK, location)
		);
	};

	componentDidMount() {
		const { getAsset, match, asset } = this.props;
		const assetId = match.params.id;
		this.populateNavBar();
		const updateManualsIncluded = (asset) => {
			const manualsIncluded = !!nullSafeGet('assetModel.manuals', asset);
			this.setState({ manualsIncluded });
		};

		if (nullSafeGet('id', asset)) {
			updateManualsIncluded(asset);
		} else {
			getAsset(assetId).then(updateManualsIncluded);
		}
	}

	handleTabChange = (key) => {
		const { history, match } = this.props;
		const assetId = match.params.id;
		history.push(`/supplier/assets/detail/${assetId}/${key}`);
	};

	checkTabActive = (key) => {
		const { history } = this.props;
		const pathname = history.location.pathname;
		return pathname.indexOf(key) !== -1;
	};

	handleDelete = () => {
		const { history, deleteAsset, asset } = this.props;
		deleteAsset(asset).then(() => {
			history.push('/supplier/assets/overview/all');
		});
	};

	openSLModal = () => this.setState({ transferModal: 'toSL' });
	openLocationModal = () => this.setState({ transferModal: 'toLocation' });
	closeTransferModal = () => this.setState({ transferModal: null });

	handleEditTransfer = () => {
		const { asset } = this.props;
		const isLocationTransfer = !!nullSafeGet('nextScheduledTransfer.state.locationId', asset);
		this.setState({ transferModal: isLocationTransfer ? 'toLocation' : 'toSL' });
	};

	handleCancelTransfer = () => {
		const { cancelScheduledTransfer, getAsset, match, asset } = this.props;
		const assetId = match.params.id;
		cancelScheduledTransfer({ assetIds: [asset.id] }).then(() => getAsset(assetId));
	};

	handleCopy = () => {
		const { match, history, userType, location } = this.props;
		const assetId = match.params.id;
		history.push(
			getLinkWIthBackLinkParams(
				location,
				'Back to asset',
				`/${userType}/assets/overview/new?copyFromAssetId=${assetId}`
			)
		);
	};

	render() {
		const {
			asset,
			assetsFetching,
			match,
			location,
			history,
			assets,
			updatePagination,
			cloneTargetCollection,
			userType,
		} = this.props;

		const assetId = match.params.id;
		let tabs = [
			{
				key: 'details',
				name: 'Overview',
			},
			{
				key: 'history',
				name: 'Transfer History',
			},
			{
				key: 'downtimeHistory',
				name: 'Downtime History',
			},
			{
				key: 'depreciationJournal',
				name: 'Depreciation Journal',
				accessPermissionName: PERMISSION_NAMES.SHOW_ASSET_PRICE,
			},
			{
				key: 'depreciationModels',
				name: 'Depreciation Models',
				accessPermissionName: PERMISSION_NAMES.SHOW_ASSET_PRICE,
			},
			{
				key: 'audit',
				name: 'Audit Logs',
			},
		];
		if (this.state.manualsIncluded) {
			tabs.push({ key: 'manuals', name: 'Manuals' });
		}
		let photoUris = [];
		let lightboxPhotoUris = [];
		if (asset.images) {
			photoUris = asset.images.slice(0, 4).map((assetImg) => {
				const [imgFileId, imgFileName] = assetImg.split('/');
				return getProtectedImageUriForSupplier(imgFileId, imgFileName, 1200, 800);
			});
			lightboxPhotoUris = asset.images.map((photoString) => ({
				src: getProtectedImageUriFromString(ROLE_TYPES.SUPPLIER)(photoString, 2400, 1600),
			}));
		}
		const fetching = assetsFetching && !nullSafeGet('id', asset);
		const scheduledTransfer = nullSafeGet('nextScheduledTransfer', asset);
		const isLocationTransfer = !!nullSafeGet('nextScheduledTransfer.state.locationId', asset);
		return (
			<div>
				<Route
					path="/supplier/assets/detail/:id"
					exact={true}
					render={() => (
						<Redirect
							to={{
								pathname: `/supplier/assets/detail/${assetId}/details`,
							}}
						/>
					)}
				/>
				<Content className="supplierAssetsDetailPage">
					<ModalGateway>
						{this.state.lightboxIsOpen ? (
							<Lightbox onClose={this.closeLightbox}>
								<Carousel
									trackProps={{
										onViewChange: this.handleViewChange,
									}}
									views={lightboxPhotoUris}
									currentIndex={this.state.currentIndex}
								/>
							</Lightbox>
						) : null}
					</ModalGateway>

					<div className="imageLayout">
						{photoUris.map((photoUri, idx) => (
							<div
								key={idx}
								className={`imageTile imageTile${idx}`}
								style={{ backgroundImage: `url(${photoUri})` }}
							/>
						))}
						<div
							className={`imageLayout__gradientOverlay ${
								asset.isActive ? '' : 'imageLayout__gradientOverlay--darker'
							}`}
						>
							{!asset.isActive ? <div className="assetInactiveLabel">Inactive</div> : null}
							<div className="supplierAssetsDetailPage__overtitle">
								{nullSafeGet('assetType.name', asset)}
							</div>
							<h4 className="supplierAssetsDetailPage__title">{fetching ? null : asset.name}</h4>
							<SubnavTabs
								tabs={tabs}
								onChange={this.handleTabChange}
								isActive={this.checkTabActive}
							/>
							<div style={{ position: 'absolute', top: 40, right: 40 }}>
								<AccessPermissionChecker name={PERMISSION_NAMES.MODIFY_ASSETS}>
									<Link
										to={getLinkWIthBackLinkParams(
											location,
											'Back to Asset',
											`/${userType}/assets/edit/${assetId}`
										)}
										style={{ marginRight: 16 }}
									>
										<Button ghost={true}>Edit</Button>
									</Link>
								</AccessPermissionChecker>
								<AccessPermissionChecker name={PERMISSION_NAMES.DELETE_ASSETS}>
									<DeleteConfirmButton
										onConfirm={this.handleDelete}
										title={'Are you sure you want to delete this asset?'}
									>
										<Button ghost={true} style={{ marginRight: 16 }}>
											Delete
										</Button>
									</DeleteConfirmButton>
								</AccessPermissionChecker>
								<AccessPermissionChecker name={PERMISSION_NAMES.MODIFY_ASSETS}>
									<Button ghost={true} onClick={this.handleCopy} style={{ marginRight: 16 }}>
										Copy and create new
									</Button>
									{scheduledTransfer ? (
										<Dropdown
											overlay={
												<Menu>
													<Menu.Item onClick={this.handleEditTransfer}>Edit Transfer</Menu.Item>
													<Menu.Item>
														<Popconfirm
															title="Cancel this scheduled transfer?"
															onConfirm={this.handleCancelTransfer}
															okText="Cancel Transfer"
															cancelText="Keep"
															okButtonProps={{ danger: true }}
														>
															<span style={{ display: 'block' }}>Cancel Transfer</span>
														</Popconfirm>
													</Menu.Item>
												</Menu>
											}
										>
											<Button ghost={true} disabled={fetching}>
												Transfer
											</Button>
										</Dropdown>
									) : (
										<Popover
											content={!asset.isActive ? 'Inactive assets cannot be transferred' : ''}
											trigger="hover"
										>
											<Dropdown
												overlay={
													<Menu>
														<Menu.Item onClick={this.openSLModal}>To Stock Location</Menu.Item>
														<Menu.Item onClick={this.openLocationModal}>To Location</Menu.Item>
													</Menu>
												}
											>
												<Button ghost={true} disabled={!asset.isActive || fetching}>
													Transfer
												</Button>
											</Dropdown>
										</Popover>
									)}
								</AccessPermissionChecker>
							</div>
							<div
								style={{ position: 'absolute', bottom: 40, right: 40 }}
								className="flex flex-row items-baseline"
							>
								{lightboxPhotoUris.length > 0 ? (
									<Button
										style={{ color: 'white' }}
										type="ghost"
										onClick={() => this.openLightbox()}
									>
										View Photos
									</Button>
								) : null}
								<NextPreviousButton
									key={this.state.fromTargetCollectionName}
									location={location}
									history={history}
									activeId={nullSafeGet('id', asset)}
									getEnitityUrl={(id) => `/supplier/assets/detail/${id}/details`}
									stateSlice={assets}
									targetCollectionName={this.state.fromTargetCollectionName}
									updatePagination={updatePagination}
									cloneTargetCollection={cloneTargetCollection}
									entityName="asset"
								/>
							</div>
						</div>
					</div>
					{this.props.childRoutes.map((r, i) => (
						<RouteWithSubRoutes key={i} {...r} />
					))}
					{this.state.transferModal === 'toSL' && (
						<BulkTransferToStockLocationModal
							assetIds={[nullSafeGet('id', asset)]}
							currentStockLocationId={nullSafeGet('stockLocation.id', asset)}
							{...(scheduledTransfer &&
								!isLocationTransfer && {
									transferId: scheduledTransfer.triggerAt,
									initialValues: getScheduledTransferInitialValues(asset),
								})}
							onCancel={this.closeTransferModal}
							onSuccess={() => {
								this.closeTransferModal();
								this.props.getAsset(assetId);
							}}
						/>
					)}
					{this.state.transferModal === 'toLocation' && (
						<BulkTransferToLocationModal
							assetIds={[nullSafeGet('id', asset)]}
							currentLocationId={nullSafeGet('location.id', asset)}
							{...(scheduledTransfer &&
								isLocationTransfer && {
									transferId: scheduledTransfer.triggerAt,
									initialValues: getScheduledTransferInitialValues(asset),
								})}
							onCancel={this.closeTransferModal}
							onSuccess={() => {
								this.closeTransferModal();
								this.props.getAsset(assetId);
							}}
						/>
					)}
				</Content>
			</div>
		);
	}
}

const mapStateToProps = (state, ownProps) => ({
	assetsFetching: state.assets.fetching,
	asset: getEntityById(ownProps.match.params.id, state.assets),
	userType: state.session.userType,
	assets: state.assets,
});

const mapDispatchToProps = (dispatch) => ({
	getAsset: (id) => dispatch(assetsRestCrudThunksForSupplier.readOne(id)),
	cancelScheduledTransfer: (data) =>
		dispatch(cancelScheduledAssetTransfer(ROLE_TYPES.SUPPLIER)(data)),
	deleteAsset: (entity) =>
		dispatch(assetsRestCrudThunksForSupplier.delete(entity, 'id', null, true)),
	updateNavbar: (backlinkTitle, backlinkTo, navbarBackgroundColor) =>
		dispatch(updateNavbarState(backlinkTitle, backlinkTo, navbarBackgroundColor)),
	clearNavbar: () => dispatch(clearNavbarState()),
	cloneTargetCollection: (from, to) =>
		dispatch(ASSETS_CRUD_ACTION_CREATORS.cloneTargetCollection(from, to)),
	updatePagination: (pagination, targetCollectionName) =>
		dispatch(
			updatePaginationEntities('supplier', 'assets', assetsRestCrudThunksForSupplier)(
				false,
				undefined,
				targetCollectionName,
				pagination,
				true
			)
		),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(SupplierAssetsDetailPage));
